"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var Centrifuge = require('centrifuge');

var SoulModule = require('./SoulModule');
/**
* Real-time messaging service
* @extends SoulModule
*/


var Centrifugo =
/*#__PURE__*/
function (_SoulModule) {
  _inherits(Centrifugo, _SoulModule);

  function Centrifugo(params) {
    var _this;

    _classCallCheck(this, Centrifugo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Centrifugo).call(this, params));
    _this.connection = null;
    _this.apiUrls = params.apiUrls;
    return _this;
  }

  _createClass(Centrifugo, [{
    key: "getJWTToken",

    /**
    * Returns JWT auth token for connect to centrifugo-service
    * @soulsdk soul.centrifugo.connectCentrifugoWS
    * @return {Promise}
    * @example
    * soul.centrifugo.connectCentrifugoWS(true);
    */
    value: function getJWTToken() {
      return this.api.post('centrifugo/get_token/');
    }
    /**
    * Callback for refresh centrifugo connection
    */

  }, {
    key: "onRefreshJWTToken",
    value: function () {
      var _onRefreshJWTToken = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(ctx, cb) {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getJWTToken();

              case 2:
                data = _context.sent;
                // Workaround for centrifuge-js lib, see https://github.com/centrifugal/centrifuge-js#refreshendpoint
                cb({
                  status: 200,
                  data: data
                });

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onRefreshJWTToken(_x, _x2) {
        return _onRefreshJWTToken.apply(this, arguments);
      }

      return onRefreshJWTToken;
    }()
    /**
    * Connects to centrifugo service
    * called after connection was established
    * @param {function} callbacks.connect
    * called when new publication message received
    * @param {function} callbacks.publish
    * called when subscription on channel successful
    * @param {function} callbacks.subscribe
    * called after disconnect
    * @param {function} callbacks.disconnect
    * @param {number} timeout
    * @soulsdk soul.centrifugo.connect
    * @example
    * soul.centrifugo.connect(
    *   {
          connect: (context) => console.log('CONNECT', context),
          publish: (message) => console.log('PUBLISH', message),
          subscribe: (message) => console.log('SUBSCRIBE', message),
          disconnect: (context) => console.log('DISCONNECT', context),
     *  },
     *  timeout,
     *);
    */

  }, {
    key: "connect",
    value: function () {
      var _connect = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee2(callbacks) {
        var timeout,
            _ref,
            token,
            centrifugo,
            _args2 = arguments;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                timeout = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 10000;

                if (this.connection) {
                  _context2.next = 11;
                  break;
                }

                _context2.next = 4;
                return this.getJWTToken();

              case 4:
                _ref = _context2.sent;
                token = _ref.token;
                centrifugo = new Centrifuge(this.wsUrl, {
                  onRefresh: this.onRefreshJWTToken.bind(this),
                  timeout: timeout
                });
                centrifugo.setToken(token);
                Object.keys(callbacks).forEach(function (key) {
                  centrifugo.on(key, callbacks[key]);
                });
                centrifugo.connect();
                this.connection = centrifugo;

              case 11:
                this.eventEmitter.on('logout', this.disconnect);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function connect(_x3) {
        return _connect.apply(this, arguments);
      }

      return connect;
    }()
    /**
    * Disconnects centrifugo connection
    * @soulsdk soul.centrifugo.disconnect
    * @example
    * soul.centrifugo.disconnect();
    */

  }, {
    key: "disconnect",
    value: function disconnect() {
      if (this.connection) {
        this.connection.disconnect();
        this.connection = null;
      }

      return true;
    }
    /**
    * Sends named RPC request
    * @param {string} method
    * @param {Object} data
    * @return {Promise}
    * @soulsdk soul.centrifugo.sendNamedRPCRequest
    * @example
    * soul.centrifugo.sendNamedRPCRequest(
    *   "random_chat.connect",
    *   { input: "value "},
    * );
    */

  }, {
    key: "sendNamedRPCRequest",
    value: function sendNamedRPCRequest(method, data) {
      if (this.connection) {
        return this.connection.namedRPC(method, data);
      }

      return Promise.reject();
    }
  }, {
    key: "wsUrl",
    get: function get() {
      return this.apiUrls.urls.centrifugoWsUrl;
    }
  }]);

  return Centrifugo;
}(SoulModule);

module.exports = Centrifugo;